<template>
    <div class="page-container">
        <!-- 顶部导航栏 -->
        <div class="nav-bar">
            <div class="nav-back" @click="onBack">
                <span class="back-arrow">‹</span>
                <span class="back-text">返回</span>
            </div>
            <span class="nav-title">选择被照护人</span>
            <div class="nav-placeholder"></div>
        </div>

        <!-- 被照护人信息 -->
        <div class="section-title">被照护人信息</div>
        <div class="section-card patient-section" @click="onSelectPatient">
            <div class="patient-info">
                <div class="patient-value">
                    <span :class="selectedPatient ? 'patient-name' : 'placeholder'">
                        {{ selectedPatient ? selectedPatient.name : '请选择被照护人' }}
                    </span>
                    <span class="patient-detail" v-if="selectedPatient">
                        {{ selectedPatient.age }}岁
                    </span>
                    <span class="patient-detail" v-if="selectedPatient">
                        {{ selectedPatient.gender }}
                    </span>
                </div>
            </div>
            <span class="arrow">></span>
        </div>

        <!-- 选择照护套餐 -->
        <div class="section-title">选择照护套餐</div>
        <div class="section-card">
            <div
                    class="package-item"
                    :class="{ selected: item.selected }"
                    v-for="(item, index) in packages"
                    :key="item.name"
                    @click="onPackageSelect(index)"
            >
                <div class="package-radio" :class="{ checked: item.selected }"></div>
                <div class="package-box">
                    <div class="package-info">
                        <span class="package-name">{{ item.name }}</span>
                        <span class="package-division" v-if="item.divisionName">
                            {{ item.divisionName }}
                        </span>
                        <span class="package-price">
                            ¥{{ item.price }}
                            <span class="package-priceDw">每天</span>
                        </span>
                    </div>
                    <div class="service-detail-btn">
                        <span :data-index="index" @click="onViewServiceDetail">
                            服务内容说明
                        </span>
                    </div>
                </div>
                <div class="arrow">></div>
            </div>
        </div>

        <!-- 选择陪护时间 -->
        <div class="section-title">选择陪护时间</div>
        <div class="section-card">
            <!-- 服务天数 -->
            <div class="param-item" @click="onDaysChange">
                <span class="param-label">服务天数</span>
                <div class="param-value">
                    <span>{{ serviceDays }}天</span>
                    <span class="arrow">></span>
                </div>
            </div>

            <van-popup v-model="show"
                       position="bottom"
                       @close="onDaysClose"
            >
                <van-picker
                        show-toolbar
                        :columns="columns"
                        :default-index="serviceDays - 1"
                        @cancel="onDaysClose"
                        @confirm="onConfirm"
                />
            </van-popup>

            <!-- 开始时间 -->
            <div class="param-item">
                <span class="param-label">开始时间</span>
                <div class="time-picker">
                    <span class="time-value" @click="openMultiSelector">
                        {{ startDateTime }} 开始
                     </span>
                </div>
            </div>

            <van-popup v-model="startDateShow"
                       position="bottom"
                       @close="onStartDateClose"
            >
                <van-datetime-picker
                        v-model="startDateTime1"
                        type="datehour"
                        title="选择年月日小时"
                        :min-date="minDate"
                        @cancel="onStartDateClose"
                        @confirm="onStartDateConfirm"

                />
            </van-popup>

            <!-- 联系人 -->
            <div class="param-item">
                <span class="param-label">联系人</span>
                <div class="param-value">
                    <input
                            class="contact-input"
                            type="number"
                            placeholder="请输入联系人手机号"
                            v-model="contactPhone"
                    />
                </div>
            </div>
        </div>

        <!-- 底部操作区 -->
        <div class="bottom-bar">
            <div class="contract-section">
                <div
                        class="contract-checkbox"
                        :class="{ checked: agreedToContract }"
                        @click="onToggleContract"
                ></div>
                <span class="contract-span">同意</span>
                <span class="contract-link" @click="onViewContract">
                    《住院陪护知情同意书》
                </span>
            </div>
            <div class="order-summary">
                <span class="summary-span">
                    预付:{{ (selectedPackage ? selectedPackage.price : 0) * serviceDays || 0 }}元,
                    共 {{ serviceDays }} 天
                </span>
            </div>
            <button class="order-btn" @click="handleOrder">立即下单</button>
        </div>

    </div>
</template>

<script>
    import {Toast} from 'vant'
    import getQRImageUrl from '@/utils/qrcode'

    export default {
        name: 'CareOrderCreate',
        data() {
            return {
                // 从上一页传递的数据
                orderInfo: {},

                // 被照护人
                selectedPatient: null,

                // 服务套餐
                packages: [],
                selectedPackage: {},
                caregiverPlanId: '',
                // 服务参数
                serviceDays: 3,
                show: false,
                columns: [],
                contactPhone: '',

                // 开始时间选择器
                startDateTime: '',
                startDateTime1: '',
                minDate: '',
                startDateShow: false,
                // 协议
                agreedToContract: false,
                signatureUrl: '',
            }
        },

        created() {
            // 获取路由参数
            this.getLocal()

            const orderData = this.$route.query.data
            if (orderData) {
                try {
                    this.orderInfo = JSON.parse(decodeURIComponent(orderData))
                    this.startDateTime?this.initStartTime(new Date(this.startDateTime)):this.initStartTime()
                    this.fetchPackageList()
                } catch (e) {
                    console.error('解析订单数据失败:', e)
                }
            }

            // 生成服务天数 1~60
            this.columns = Array.from({length: 60}, (_, i) => i + 1)

        },


        methods: {
            getLocal() {
                const signatureUrl = localStorage.getItem('signatureUrl')
                if (signatureUrl) {
                    this.signatureUrl = signatureUrl
                    this.agreedToContract = true
                }

                // 被照护人
                const selectedPatient = JSON.parse(localStorage.getItem('selectedPatient')) || null;

                if (selectedPatient) {
                    this.selectedPatient = selectedPatient
                }

                const orderDetail = JSON.parse(localStorage.getItem('orderDetail')) || {};

                this.caregiverPlanId = orderDetail.caregiverPlanId || ''
                this.serviceDays = orderDetail.serviceDays || 3
                this.startDateTime = orderDetail.startDateTime || this.startDateTime
                this.contactPhone = orderDetail.contactPhone || ''


            },
            /**
             * 初始化开始日期和时间
             */
            initStartTime(dateTime) {
                const now = dateTime || new Date();

                const curYear = now.getFullYear();
                const curMonth = now.getMonth() + 1;
                const curDay = now.getDate();
                const curHour = now.getHours();

                // 年份：当前年 ~ +5年
                const years = [];
                for (let y = curYear; y <= curYear + 5; y++) years.push(`${y}年`);
                // 月份：01~12
                const months = [];
                for (let m = 1; m <= 12; m++) months.push(`${String(m).padStart(2, '0')}月`);
                // 日：根据当前年月生成
                const days = this._buildDays(curYear, curMonth);
                // 时：00~23
                const hours = [];
                for (let h = 0; h < 24; h++) hours.push(`${String(h).padStart(2, '0')}时`);

                this.minDate = new Date()
                this.startDateTime = this._formatDateTime(curYear, curMonth, curDay, curHour)
                this.startDateTime1 = new Date(this.startDateTime)
            },

            /**
             * 生成指定年月的日数数组
             */
            _buildDays(year, month) {
                const dim = new Date(year, month, 0).getDate();
                const days = [];
                for (let d = 1; d <= dim; d++) days.push(`${String(d).padStart(2, '0')}日`);
                return days;
            },
            _formatDate(y, m, d) {
                return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
            },

            _formatDateTime(y, m, d, h) {
                return `${this._formatDate(y, m, d)} ${String(h).padStart(2, '0')}:00`;
            },
            /**
             * 获取套餐列表
             */
            async fetchPackageList() {
                let _this=this
                const {enterpriseId, divisionId} = this.orderInfo
                if (!enterpriseId) {
                    console.error('缺少enterpriseId参数')
                    return
                }

                try {
                    const params = {enterpriseId}
                    if (divisionId) params.divisionId = divisionId
                    let url = "/api-enterprise/caregiverPlan/list"
                    this.$api.post(url, params, response => {
                        if (response.data.result == "success") {
                            let datas = response.data.data || []

                            if(_this.caregiverPlanId){
                                 datas.map(item=>{
                                    if(item.id==_this.caregiverPlanId){
                                        item.selected=true
                                        _this.selectedPackage=item
                                    }
                                })
                                _this.packages=datas
                            }else{
                                this.packages = datas.map((item, index) => ({
                                    ...item,
                                    selected: index === 0
                                }))
                                this.selectedPackage = this.packages[0] || {}
                            }

                        }
                    })
                } catch (err) {
                    console.error('fetchPackageList fail:', err)
                    this.$toast('获取套餐列表失败')
                }
            },

            /**
             * 选择服务套餐
             */
            onPackageSelect(index) {

                this.packages = this.packages.map((pkg, i) => ({
                    ...pkg,
                    selected: i === index
                }))
                this.selectedPackage = this.packages[index]
            },

            /**
             * 打开服务天数选择
             */
            onDaysChange() {
                this.show = true
            },

            onDaysClose() {
                this.show = false
            },

            onConfirm(event) {
                this.show = false
                this.serviceDays = event
            },


            /**
             * 勾选协议
             */
            onToggleContract() {
                this.agreedToContract = !this.agreedToContract
            },

            /**
             * 查看协议
             */
            onViewContract() {
                this.setLocalOrder()
                this.$router.push('/agreement')
            },

            /**
             * 选择被照护人
             */
            onSelectPatient() {
                this.setLocalOrder()
                this.$router.push({
                    path: '/patientList',
                    query: {enterpriseId: this.orderInfo.enterpriseId}
                })
            },

            /**
             * 立即下单
             */
            async handleOrder() {
                if (!this.selectedPatient) {
                    this.$toast('请选择被照护人')
                    return
                }
                if (!this.signatureUrl) {
                    this.$toast('请先签名')
                    return
                }
                if (!this.agreedToContract) {
                    this.$toast('请先同意住院陪护知情同意书')
                    return
                }
                if (!this.contactPhone) {
                    this.$toast('请输入联系人手机号')
                    return
                }

                const orderData = {
                    caregiverPlanId: this.selectedPackage.caregiverPlanId || this.selectedPackage.id,
                    serviceDays: this.serviceDays,
                    startTime: this.startDateTime,
                    bedNumber: this.orderInfo.bedNumber,
                    patientId: this.selectedPatient.id,
                    contactPhone: this.contactPhone,
                    signatureUrl: this.signatureUrl
                }

                try {
                    // 创建订单
                    let url = "/api-enterprise/caregiver/order/create3"

                    this.$api.post(url, orderData, response => {
                        if (response.data.result == "success") {
                            const orderId = response.data.orderId
                            this.$router.push({
                                path: '/orderDetail',
                                query: {orderId: orderId}
                            })
                        }
                    })


                } catch (err) {
                    this.$loading.hide()
                    this.$toast('网络请求失败')
                    console.error('下单失败:', err)
                }
            },


            /**
             * 返回
             */
            onBack() {
                this.$router.back()
            },

            /**
             * 查看服务说明
             */
            onViewServiceDetail(e) {
                const index = e.currentTarget.dataset.index
                const pkg = this.packages[index]

                if (pkg?.description) {
                    this.$dialog.alert({
                        title: '服务内容说明',
                        message: pkg.description
                    })
                } else {
                    this.$toast('暂无服务说明')
                }
            },
            openMultiSelector() {
                this.startDateShow = true
            },
            onStartDateClose() {
                this.startDateShow = false
            },
            onStartDateConfirm(e) {
                this.initStartTime(e)
                this.startDateShow = false
            },
            setLocalOrder() {
                let obj = {
                    serviceDays: this.serviceDays,
                    startDateTime: this.startDateTime,
                    caregiverPlanId: this.selectedPackage.caregiverPlanId || this.selectedPackage.id,
                    contactPhone: this.contactPhone,
                }
                localStorage.setItem('orderDetail', JSON.stringify(obj));
            },
        },

    }
</script>

<style scoped>
    .page-container {
        min-height: 100vh;
        background-color: #f5f5f5;
        padding-bottom: 150px;
    }

    /* 导航栏 */
    .nav-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 44px;
        padding: 0 15px;
        background-color: #fff;
        border-bottom: 1px solid #eee;
    }

    .nav-back {
        display: flex;
        align-items: center;
        gap: 2.5px;
        cursor: pointer;
    }

    .back-arrow {
        font-size: 16px;
        color: #07c160;
    }

    .back-text {
        font-size: 14px;
        color: #07c160;
    }

    .nav-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
    }

    .nav-placeholder {
        width: 50px;
    }

    /* 卡片样式 */
    .section-card {
        background-color: #fff;
        margin: 10px 12px;
        border-radius: 8px;
        padding: 15px;
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
    }

    /* 被照护人选择区域 */
    .patient-section {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .patient-info {
        flex: 1;
        display: flex;
        align-items: center;
    }

    .patient-label {
        font-size: 14px;
        color: #333;
        margin-right: 10px;
    }

    .patient-value {
        flex: 1;
        display: flex;
        align-items: center;
    }

    .patient-value span {
        display: flex;
        align-items: center;
    }

    .patient-name {
        font-size: 14px;
        color: #333;
        font-weight: bold;
    }

    .patient-detail {
        font-size: 15px;
        margin: 0 5px;
        color: rgba(0, 184, 147, 0.72);
        background: rgba(187, 187, 187, 0.3);
        border-radius: 5px 5px 5px 5px;
        padding: 3px 5px;
    }

    .placeholder {
        font-size: 14px;
        color: #999;
    }

    /* 套餐选择 */
    .package-item {
        display: flex;
        align-items: center;
        padding: 12px 0;
        border-bottom: 1px solid #f0f0f0;
        position: relative;
    }

    .package-item:last-child {
        border-bottom: none;
    }

    .package-item.selected {
        background-color: #f8f9ff;
    }

    .package-box {
        flex: 1;
        padding: 0 10px;
    }

    .package-info {
        flex: 1;
        display: flex;
        align-items: center;
    }

    .package-name {
        font-size: 15px;
        font-weight: bold;
        color: #333;
        display: block;
        flex: 1;
    }

    .package-price {
        font-size: 14px;
        color: rgba(0, 184, 147, 0.72);
        display: block;
        width: 75px;
        margin-left: 10px;
        span-align: right;
    }

    .package-priceDw {
        color: #999999 !important;
    }

    .package-division {
        font-size: 12px;
        color: rgba(0, 184, 147, 0.72);
        display: block;
        background: rgba(187, 187, 187, 0.3);
        padding: 5px;
    }

    .package-tag {
        display: inline-block;
        font-size: 10px;
        color: #ff6b00;
        border: 1px solid #ff6b00;
        padding: 1px 5px;
        border-radius: 3px;
        margin-top: 4px;
    }

    .package-radio {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #ddd;
        margin-left: 10px;
    }

    .package-radio.checked {
        border-color: #07c160;
        background-color: #07c160;
        position: relative;
    }

    .package-radio.checked::after {
        content: '✓';
        position: absolute;
        color: #fff;
        font-size: 12px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .service-detail-btn {
        span-align: right;
    }

    .service-detail-btn span {
        font-size: 12px;
        color: #666;
        span-decoration: underline;
    }

    /* 参数配置 */
    .param-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 0;
        border-bottom: 1px solid #f0f0f0;
    }

    .param-item:last-child {
        border-bottom: none;
    }

    .param-label {
        font-size: 14px;
        color: #333;
    }

    .param-value {
        display: flex;
        align-items: center;
    }

    .param-value span {
        font-size: 14px;
        color: #666;
    }

    .arrow {
        margin-left: 5px;
        color: #999;
    }

    .contact-input {
        /* 去掉边框 */
        border: none;
        outline: none;
        background: transparent;
        /* 占位文字和输入文字都右对齐 */
        text-align: right;
        font-size: 14px;
        color: #333;
        width: 100%;
    }

    .contact-input::placeholder {
        color: #999;
        /* 确保占位文字右对齐 */
        text-align: right;
    }

    /* 时间选择器 */
    .time-picker {
        display: flex;
        align-items: center;
    }

    .time-value {
        font-size: 14px;
        color: #666;
    }

    .time-separator {
        margin: 0 5px;
        color: #666;
    }

    /* 底部操作区 */
    .bottom-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #fff;
        padding: 10px 15px;
        /*padding-bottom: calc(10px + env(safe-area-inset-bottom));*/

        box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.05);
        z-index: 10;
    }

    .contract-section {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
    }

    .contract-checkbox {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid #ddd;
        margin-right: 6px;
    }

    .contract-checkbox.checked {
        border-color: #07c160;
        background-color: #07c160;
        position: relative;
    }

    .contract-checkbox.checked::after {
        content: '✓';
        position: absolute;
        color: #fff;
        font-size: 10px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .contract-span {
        font-size: 13px;
        color: #666;
    }

    .contract-link {
        font-size: 13px;
        color: rgba(0, 184, 147, 0.72);
    }

    .order-summary {
        margin-bottom: 8px;
    }

    .summary-span {
        font-size: 14px;
        color: #333;
        font-weight: bold;
    }

    .order-btn {
        display: block;
        padding: 0;
        margin: auto;
        width: 100%;
        height: 44px;
        line-height: 44px;
        background-color: rgba(0, 184, 147, 0.72);
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        border-radius: 22px;
        border: none;
    }

    .order-btn::after {
        border: none;
    }

    /* 二维码支付弹窗 */
    .qr-modal-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .qr-modal {
        width: 290px;
        background: #ffffff;
        border-radius: 12px;
        padding: 25px 20px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .qr-modal-title {
        font-size: 17px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 8px;
    }

    .qr-modal-tip {
        font-size: 13px;
        color: #999999;
        margin-bottom: 20px;
    }

    .qr-modal-image {
        width: 200px;
        height: 200px;
        margin-bottom: 10px;
    }

    .qr-modal-hint {
        font-size: 12px;
        color: #999999;
        margin-bottom: 15px;
    }

    .qr-modal-polling {
        font-size: 12px;
        color: #007aff;
        margin-bottom: 10px;
    }

    .qr-modal-close {
        width: 100%;
        height: 40px;
        line-height: 40px;
        background: #f5f5f5;
        color: #666666;
        font-size: 15px;
        border-radius: 20px;
        border: none;
    }

    .qr-modal-close::after {
        border: none;
    }

    .section-title {
        font-size: 13px;
        color: #101010;
        padding: 10px 15px 5px;
    }
</style>
